import Vue from 'vue';
import { i18n, loadDefaultLanguage } from '@v4/locale/async';
import VueModal from 'vue-js-modal';
import Toasted from 'vue-toasted';
import smoothscroll from 'smoothscroll-polyfill';
import registerFilters from '@v4/common/filters';
import Header from '@v4/header';
import { getJsonDataFromScript } from '@v4/common/utils/json';
import { API_RESOURCE_DRIVESPARK_OFFERS } from '@v4/search/config';
import SearchPage from '@v4/search/components/pages/SearchPage.vue';
import methods from '@v4/single-collection/methods';
import computed from '@v4/single-collection/computed';
import '@v4/common/utils/lazy-load';

(async () => {
    await loadDefaultLanguage();

    if (document.getElementById('header')) {
        Header();
    }

    const el = document.getElementById('single-collection');

    if (!el) {
        return;
    }

    Vue.use(VueModal, { dynamic: true, injectModalsContainer: true });
    Vue.use(Toasted);
    smoothscroll.polyfill();

    registerFilters(Vue);

    new Vue({
        el,
        i18n,
        components: {
            SearchPage,
        },
        data() {
            return {
                apiResource: API_RESOURCE_DRIVESPARK_OFFERS,
                offersData: getJsonDataFromScript('#single-collection-data'),
            };
        },
        computed,
        methods,
    });
})();
